/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ShareService } from '@app/app/shared/services/share/share.service';
import { V3NewMomentDialogComponent } from '../../../page-modules/folio/v3-shared-moment-module/components/v3-new-moment-dialog/v3-new-moment-dialog.component';
import { LanguageCodeHelper } from '../../../shared/helpers/language-code-helper';

@Component({
  templateUrl: './share-event.component.html',
  styleUrls: ['./share-event.component.scss'],
})
export class ShareEventComponent implements OnInit {
  shareUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      shareUrl: string;
    },
    private dialogRef: MatDialogRef<ShareEventComponent>,
    private shareService: ShareService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.shareUrl = this.data.shareUrl;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  openNewMomentDialog(): void {
    this.dialog.open(V3NewMomentDialogComponent, {
      width: '47rem',
      maxWidth: '90vw',
      disableClose: true,
      maxHeight: 'auto',
      position: {
        top: '10vh',
      },
      direction: LanguageCodeHelper.getBodyLanguageDir(),
      panelClass: ['v3-moment-dialog-container'],
      backdropClass: 'dialog-backdrop',
      data: {
        addToFolio: true,
        prefillContent: this.shareUrl,
      },
    });
  }

  copyLink(): void {
    this.shareService.shareAction('copy', this.shareUrl);
  }
}
